const DEVICE_ID_KEY = "eternua.device.id.v1";

function randomHex(size = 32) {
  const bytes = new Uint8Array(size);
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function getOrCreateDeviceId() {
  if (typeof window === "undefined") return "";
  try {
    const existing = window.localStorage.getItem(DEVICE_ID_KEY);
    if (existing && existing.length >= 16) return existing;
    const generated = `dev_${Date.now().toString(36)}_${randomHex(16)}`;
    window.localStorage.setItem(DEVICE_ID_KEY, generated);
    return generated;
  } catch (_e) {
    return `dev_fallback_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
  }
}
